export const GET_COMMUNITIES = 'GET_COMMUNITIES'
export const GET_COMMUNITIES_RESULT = 'GET_COMMUNITIES_RESULT'
export const COMMUNITY_LOAD_START = 'COMMUNITY_LOAD_START'
export const COMMUNITY_LOAD_END = 'COMMUNITY_LOAD_END'


// WEBPACK FOOTER //
// ./src/constants/Home.js